export enum EntityClassNames {
  CONTEXT_MENU = "entity-context-menu",
  CONTEXT_MENU_CONTENT = "entity-context-menu-content",
}

export const DEFAULT_DATA_TEST_ID = "t--more-action-trigger";
export const DEFAULT_TOOLTIP_CONTENT = "More actions";
